import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import IntegrationHooks from './IntegrationHooks.vue';
import Index from './Index.vue';
import Webhook from './Webhooks/Index.vue';
import DashboardApps from './DashboardApps/Index.vue';
import Slack from './Slack.vue';
import Linear from './Linear.vue';
import Notion from './Notion.vue';
import Shopify from './Shopify.vue';

// An integration page sits under Integrations in the Topbar trail ("Integrations › Slack", R2-9-10): the list is
// the link back, the integration's name (from the store the page reads) is the page. It is not kept alive by
// SettingsWrapper (`keepAlive: false`): kept, it re-rendered against the routes opened after it.
const integrationName = id => (route, store) =>
  store.getters['integrations/getIntegration'](id)?.name;

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'settings_applications',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'dashboard_apps',
          component: DashboardApps,
          name: 'settings_integrations_dashboard_apps',
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            trailParent: 'settings_applications',
            trailLabel: 'INTEGRATION_SETTINGS.DASHBOARD_APPS.TITLE',
          },
        },
        {
          path: 'webhook',
          component: Webhook,
          name: 'settings_integrations_webhook',
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            trailParent: 'settings_applications',
            trailLabel: 'INTEGRATION_SETTINGS.WEBHOOK.TITLE',
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      children: [
        {
          path: 'slack',
          name: 'settings_integrations_slack',
          component: Slack,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            trailParent: 'settings_applications',
            trailDetail: integrationName('slack'),
            keepAlive: false,
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'linear',
          name: 'settings_integrations_linear',
          component: Linear,
          meta: {
            permissions: ['administrator'],
            trailParent: 'settings_applications',
            trailDetail: integrationName('linear'),
            keepAlive: false,
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'notion',
          name: 'settings_integrations_notion',
          component: Notion,
          meta: {
            permissions: ['administrator'],
            trailParent: 'settings_applications',
            trailDetail: integrationName('notion'),
            keepAlive: false,
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'shopify',
          name: 'settings_integrations_shopify',
          component: Shopify,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            trailParent: 'settings_applications',
            trailDetail: integrationName('shopify'),
            keepAlive: false,
          },
          props: route => ({ error: route.query.error }),
        },
        {
          path: ':integration_id',
          name: 'settings_applications_integration',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            trailParent: 'settings_applications',
            trailDetail: (route, store) =>
              store.getters['integrations/getIntegration'](
                route.params.integration_id
              )?.name,
            keepAlive: false,
          },
          props: route => ({
            integrationId: route.params.integration_id,
          }),
        },
      ],
    },
  ],
};
